import { CaseReducer, PayloadAction } from '@reduxjs/toolkit'
import {
  FinancialDto,
  MoneyDto,
  QuantityDto,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { ProjectState } from 'store/Project/ProjectTypes'

const GetEmptyMoneyDto = (moneyDto: MoneyDto) => {
  return {
    ...moneyDto,
    value: undefined,
  }
}

const GetEmptyQuantityDto = (quantityDto: QuantityDto) => {
  return {
    ...quantityDto,
    value: undefined,
  }
}

const getResetedFinancials = (financial: FinancialDto) => {
  const emptyMoneyDto = GetEmptyMoneyDto({ ...financial['costPricePerItem'] })
  return {
    ...financial,
    costPriceOfItems: emptyMoneyDto,
    salesPriceOfItems: emptyMoneyDto,
    salesPricePerItem: emptyMoneyDto,
    totalProjectQuantity: undefined,
    discountValueOfItems: emptyMoneyDto,
    discountValuePerItem: emptyMoneyDto,
    surchargeValueOfItems: emptyMoneyDto,
    surchargeValuePerItem: emptyMoneyDto,
    surchargeRatio: GetEmptyQuantityDto(financial.surchargeRatio),
    discountRatio: GetEmptyQuantityDto(financial.discountRatio),
  } as FinancialDto
}

export const resetBomItemFinancials: CaseReducer<
  ProjectState,
  PayloadAction<string[]>
> = (state, action) => {
  action.payload.forEach((bomItemId) => {
    if (bomItemId === state.activeProject?.id) {
      state.activeProject.financial = getResetedFinancials(
        state.activeProject.financial
      )

      state.assemblyHeadersIds?.forEach((assemblyHeaderId) =>
        resetBomItemFinancials(state, { type: '', payload: [assemblyHeaderId] })
      )
    }

    const bomItem = state.flatView[bomItemId] || state.treeView[bomItemId]

    if (!bomItem) return

    switch (bomItem.type) {
      case 'AssemblyHeader': {
        bomItem.assembly.financial = getResetedFinancials(
          bomItem.assembly.financial
        )

        resetBomItemFinancials(state, {
          type: '',
          payload: bomItem.assembly.partTypeIds,
        })
        break
      }
      case 'Assembly': {
        bomItem.financial = getResetedFinancials(bomItem.financial)
        resetBomItemFinancials(state, {
          type: '',
          payload: bomItem.partTypeIds,
        })
        break
      }
      case 'Row': {
        bomItem.financial = getResetedFinancials(bomItem.financial)
      }
    }
    Object.keys(state.priceSummaries).forEach((priceSummaryId) => {
      state.priceSummaries[priceSummaryId] = {
        ...state.priceSummaries[priceSummaryId],
        totalSalesPrice: GetEmptyMoneyDto(
          state.priceSummaries[priceSummaryId].totalSalesPrice
        ),
      }
    })
  })
}
